import { TFunction } from 'i18next';
import { RSidbarItem } from '../../RightSideBar';
import Assets from 'assets/icons';
import { LinkOutlined } from '@ant-design/icons';

export const getChatSettingData = (
  t: TFunction,
  extra?: {
    links?: RSidbarItem[];
    files?: RSidbarItem[];
    media?: RSidbarItem[];
    audio?: RSidbarItem[];
    members: RSidbarItem[];
  }
): RSidbarItem => {
  return {
    name: t('rightSideBar.chat_setting'),
    type: 'folder',
    children: [
      {
        name: t('Chats.settings.settings'),
        type: 'folder',
        icon: <Assets.SettingsIcon />,
        exceptionKeys: [2, 3],
        children: [
          {
            name: t('Chats.settings.members'),
            count: extra?.members.length,
            type: 'folder',
            icon: <Assets.MembersIcon />,
            children: extra?.members,
          },
        ],
      },

      { name: t('Chats.settings.shared'), type: 'divider' },
      // { name: t('Chats.settings.media'), type: 'folder', icon: <Assets.BellIcon /> },
      // { name: t('Chats.settings.audio'), type: 'folder', icon: <Assets.BellIcon /> },
      // { name: t('Chats.settings.files'), type: 'folder', icon: <Assets.FileIcon /> },
      {
        name: t('Chats.settings.links'),
        type: 'folder',
        icon: <LinkOutlined style={{ fontSize: '24px' }} />,
        children: extra?.links,
        count: extra?.links?.length,
      },
    ],
  };
};
